import { Link } from 'react-router-dom';
import { genres } from '@/mocks/manhwa';

const siteLinks = [
  { label: '首页', to: '/' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
  { label: '热门韩漫', to: '/#popular' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-palette-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-background-50">漫画韩漫网址</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90">
              专注于整理和分类优质韩漫的题材导航站，恋爱、都市、奇幻、校园、悬疑、热血一应俱全，帮你在海量内容中快速找到心仪的漫画。
            </p>
          </div>

          <div>
            <h3 className="text-background-50 font-medium mb-4 text-sm tracking-wide">快速导航</h3>
            <ul className="space-y-3">
              {siteLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-200/90 hover:text-background-50 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-background-50 font-medium mb-4 text-sm tracking-wide">题材分类</h3>
            <ul className="space-y-3">
              {genres.slice(0, 6).map((g) => (
                <li key={g.id}>
                  <Link
                    to={`/category/${g.id}`}
                    className="text-sm text-background-200/90 hover:text-background-50 transition-colors"
                  >
                    {g.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-background-50 font-medium mb-4 text-sm tracking-wide">关注我们</h3>
            <p className="text-sm text-background-200/90 leading-relaxed mb-4">
              更多韩漫推荐与最新更新，欢迎通过下方方式与我们联系。
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  className="w-10 h-10 rounded-full bg-primary-700 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors"
                  aria-label="社交联系方式"
                >
                  <i className={icon} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/80">© 2026 漫画韩漫网址 · 用心整理每一部韩漫</p>
          <p className="text-xs text-background-200/80">题材分类 · 精选推荐 · 快速定位想看的韩漫</p>
        </div>
      </div>
    </footer>
  );
}